module.exports = __webpack_public_path__ + "static/media/kotlin.fe42529a.svg";